import React from 'react';
import locationViewPropShape from '../../propTypes/locationView';
import Breadcrumb from '../Breadcrumb';
import { camsAndForecastsPaths } from '../../utils/urls/camsAndForecastsPath';

const GeonameMapHeader = ({ locationView }) => (
  <div className="sl-geoname-map-header">
    <Breadcrumb breadcrumbs={locationView.breadCrumbs} baseUrl={`${camsAndForecastsPaths.base}`} />
    <h1>{`${locationView.taxonomy.name || ''} Surf Reports & Cams`}</h1>
  </div>
);

GeonameMapHeader.propTypes = {
  locationView: locationViewPropShape.isRequired,
};

export default GeonameMapHeader;
